import PromotionalCodeContainer from './PromotionalCodeContainer';

export default PromotionalCodeContainer;
